module.exports = __webpack_public_path__ + "static/media/BlogVFD.f05f64e1.jpg";